import React, { useEffect, useMemo, useState } from 'react';
import { IFolderAndFile } from '../api/document-api';
import SearchField from '../components/SearchField';
import ReactTable from '../components/ReactTable';
import SortFileDirectory from '../components/SortFileDirectory';
import Helper from '../utils/Helper';
import moment from 'moment';
import { Link, useLocation } from 'react-router-dom';
// import useMobileView from '../hooks/useMobileView';

type Props = {
    data: IFolderAndFile[],
    onDoubleClick: (event: React.MouseEvent<HTMLDivElement | HTMLSpanElement | HTMLButtonElement, MouseEvent>, data: IFolderAndFile, type: 'file' | 'folder') => any,
    onContextMenu: (event: React.MouseEvent<HTMLDivElement | HTMLSpanElement | HTMLButtonElement, MouseEvent>, data: IFolderAndFile, type: 'file' | 'folder') => any,
    onSingleAction: (event: React.MouseEvent<HTMLDivElement | HTMLSpanElement | HTMLButtonElement, MouseEvent>, data: IFolderAndFile, type: 'file' | 'folder') => any,
};

const Folders: React.FC<Props> = ({ data, onDoubleClick, onContextMenu, onSingleAction }) => {
    const [filterData, setFilterData] = useState<IFolderAndFile[] | []>([])
    const [searchValue, setSearchValue] = useState('')
    const [sortBy, setSortBy] = useState('')
    const [sortType, setSortType] = useState<'asc' | 'desc' | string>('asc')
    const [isGrid, setIsGrid] = useState(false)

    // const isMobile = useMobileView()
    const {pathname} = useLocation()

    useEffect(() => {
        const newData = [...data]
        if (searchValue) {
            const filtered = newData.filter((item: IFolderAndFile) => {
                return (
                    item?.name?.toLowerCase().includes(searchValue.toLowerCase())
                )
            });

            setFilterData(filtered)
        } else {
            setFilterData(data)
        }
    }, [searchValue, data])

    useEffect(() => {
        setSearchValue('')
    }, [data])

    useEffect(() => {
        if (sortBy) {
            const noSortData = [...filterData]
            const sortData = Helper.orderFileFolder(noSortData, sortBy, sortType)
            setFilterData(sortData)
        } else {
            setFilterData(data)
        }
        // eslint-disable-next-line
    }, [sortBy, sortType])


    const COLUMNS = useMemo(() => [
        {
            Header: () => <span className='p-4'>Name</span>,
            accessor: 'name',
            width: 400,
            Cell: ({ value }: any) => {
                return (
                    <Link to={pathname + '/' + value} className='text-left pl-4 flex items-center'>
                        <i className='ri-folder-3-fill flex items-center mr-1.5 text-xl -my-5'></i>
                        <p>{value}</p>
                    </Link>
                )
            },
        },
        {
            Header: 'Date modified',
            accessor: 'last_modified',
            width: 170,
            Cell: ({ value, row }: any) => {
                const data = row.original
                // return moment(value).format('DD-MM-yyyy HH:mm:ss')
                return <Link to={pathname + '/' + data?.name}>{moment(value).format('DD-MM-yyyy HH:mm:ss')}</Link>
            }
        },
        {
            Header: 'Type',
            accessor: 'extension',
            width: 60,
            Cell: ({ value, row }: any) => {
                const data = row.original
                return <Link to={pathname + '/' + data?.name}>{value}</Link>
            }
        },
        {
            Header: 'Size',
            accessor: 'size',
            width: 100,
            Cell: ({ row }: any) => {
                const data = row.original
                // return data?.size + ' ' + data?.measure
                return <Link to={pathname + '/' + data?.name}>{data?.size + ' ' + data?.measure}</Link>
            }
        },
        {
            Header: 'Action',
            accessor: 'action',
            width: 50,
            Cell: ({ row }: any) => {
                const data = row.original
                // return <DropdownSingleAction type='file' />
                return (
                    <button onClick={(e) => onSingleAction(e, data, 'folder')} className="relative z-5 rounded-md focus:outline-none flex items-center bg-orange-400 hover:bg-orange-500 focus:ring-4 focus:ring-orange-400 text-white px-2.5 py-1">
                        <i className="ri-settings-line text-lg"></i>
                    </button>
                )
            }
        }
    ], [onSingleAction, pathname])

    return (
        <div>
            <div className='flex items-center justify-between border-b border-slate-300 dark:border-slate-800'>
                <h3 className='font-bold text-slate-700 dark:text-slate-100 w-full'>Directories</h3>
                <SearchField placeholder='Search folder...' onChange={(e) => setSearchValue(e.target.value)} clearSearch={() => setSearchValue('')} value={searchValue} />
            </div>


            {filterData.length > 0 ?
                <>
                    {isGrid ?
                        <>
                            <div className='flex item-center justify-between my-5'>
                                <button className='btn-primary w-8 h-8 p-0 text-xl rounded-md' onClick={() => setIsGrid(!isGrid)}>
                                    {isGrid ? <i className='bi bi-grid-fill'></i> : <i className='bi bi-list-check'></i>}
                                </button>

                                <SortFileDirectory
                                    sortByValue={sortBy} onSortByChange={(e) => setSortBy(e.target.value)}
                                    sortTypeValue={sortType} onSortTypeChange={(e) => setSortType(e.target.value)}
                                />
                            </div>
                            <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6'>
                                {
                                    filterData.map((data, key) =>
                                        <button key={key} onDoubleClick={(e) => onDoubleClick(e, data, 'folder')} onContextMenu={(e) => onContextMenu(e, data, 'folder')} /* onClick={(e) => isMobile && onContextMenu(e, data, 'folder')} */
                                            className='bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 hover:dark:bg-slate-700 text-slate-600 hover:text-slate-700 dark:text-slate-300 hover:dark:text-slate-100 border-2 border-slate-300 hover:border-slate-400 dark:border-slate-700 hover:dark:border-slate-100 w-40 h-[7rem] rounded-xl flex flex-col items-center justify-end font-medium m-2 lg:m-3'>
                                            <i className='ri-folder-3-fill text-6xl'></i>
                                            <p className='mb-2 mt-1.5'>{data.name!.length > 15 ? data.name?.substring(0, 15) + '...' : data.name}</p>
                                        </button>
                                    )}
                            </div>
                        </>
                        :
                        <>
                            <div className='flex item-center justify-between my-5'>
                                <button className='btn-primary w-8 h-8 p-0 text-xl rounded-md shadow-lg' onClick={() => setIsGrid(!isGrid)}>
                                    {isGrid ? <i className='bi bi-grid-fill'></i> : <i className='bi bi-list-check'></i>}
                                </button>
                            </div>
                            <ReactTable 
                                dataTable={filterData} columnTable={COLUMNS}
                                // onClickRow={(e: any, row: IFolderAndFile) => isMobile && onContextMenu(e, row, 'folder')} 
                                onDoubleClickRow={(e: any, row: IFolderAndFile) => onDoubleClick(e, row, 'folder')} 
                                onRightClick={(e: any, row: IFolderAndFile) => {return}} />
                        </>
                    }
                </>
                :
                <div className='flex items-center justify-center h-32'>
                    <p>No folder exist</p>
                </div>
            }
        </div>
    );
}

export default Folders;